import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';

import { BudgetCompareMenuComponent } from '@widgets/budget-compare-menu/budget-compare-menu.component';
import { GenericBudgetCompareMenuComponent } from '@widgets/budget-compare-menu/classes/budget-compare-menu.class';

import { BudgetService } from '@features/budget/services/budget.service';
import { SnapshotService } from '@features/budget/services/snapshot.service';

import { TrialInsightsStore } from '@models/trial-insights/trial-insights.store';

import { EventService } from '@shared/store/event/event.service';
import { MainQuery } from '@shared/store/main/main.query';
import { OrganizationQuery } from '@shared/store/organization/organization.query';
import { OrganizationService } from '@shared/store/organization/organization.service';
import { OrganizationStore } from '@shared/store/organization/organization.store';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BudgetCompareMenuComponent],
  selector: 'aux-trial-insights-finance-bva-chart-menu',
  styleUrls: ['../../trial-insights.component.scss'],
  templateUrl: './bva-chart-menu.component.html',
})
export class TrialInsightsFinanceBvaChartMenuComponent
  extends GenericBudgetCompareMenuComponent
  implements OnInit
{
  budgetService: BudgetService;
  cdr: ChangeDetectorRef;
  eventService: EventService;
  mainQuery: MainQuery;
  organizationQuery: OrganizationQuery;
  organizationService: OrganizationService;
  organizationStore: OrganizationStore;
  snapshotService: SnapshotService;
  trialInsightsStore: TrialInsightsStore;

  ngOnInit(): void {
    this.initializeSubscriptions();
  }

  constructor() {
    const cdr = inject(ChangeDetectorRef);
    const mainQuery = inject(MainQuery);
    const eventService = inject(EventService);
    const organizationService = inject(OrganizationService);
    const organizationStore = inject(OrganizationStore);
    const organizationQuery = inject(OrganizationQuery);
    const snapshotService = inject(SnapshotService);
    const budgetService = inject(BudgetService);
    const trialInsightsStore = inject(TrialInsightsStore);

    super({
      budgetService,
      cdr,
      eventService,
      mainQuery,
      organizationQuery,
      organizationService,
      organizationStore,
      snapshotService,
      trialInsightsStore,
    });

    this.cdr = cdr;
    this.mainQuery = mainQuery;
    this.eventService = eventService;
    this.organizationService = organizationService;
    this.organizationStore = organizationStore;
    this.organizationQuery = organizationQuery;
    this.snapshotService = snapshotService;
    this.budgetService = budgetService;
    this.trialInsightsStore = trialInsightsStore;
  }
}
